/* Version F: callback service is not in use. Remove any legacy callback CTAs
   that may still be emitted by older JSON template settings or app rerenders. */
(() => {
  'use strict';

  const phoneHref = 'tel:+448001577574';
  const phoneText = '0800 157 7574';

  const phoneLink = (className = '') => {
    const link = document.createElement('a');
    link.href = phoneHref;
    link.textContent = phoneText;
    if (className) link.className = className;
    return link;
  };

  const clean = root => {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('a[href*="/pages/request-a-callback"]').forEach(link => {
      const paragraph = link.closest('p');
      const existingPhone = paragraph && paragraph.querySelector('a[href^="tel:"]');
      const text = paragraph ? paragraph.textContent.trim().toLowerCase() : '';

      if (paragraph && existingPhone && text.includes('questions before ordering')) {
        paragraph.innerHTML = 'Questions before ordering? Call <a href="' + phoneHref + '">' + phoneText + '</a>.';
        return;
      }

      link.replaceWith(phoneLink(link.className));
    });

    root.querySelectorAll('[data-ph-callback-open]').forEach(control => {
      const paragraph = control.closest('p');
      const existingPhone = paragraph && paragraph.querySelector('a[href^="tel:"]');

      if (paragraph && existingPhone) {
        control.remove();
        paragraph.innerHTML = paragraph.innerHTML
          .replace(/\s*or\s+call\s*/i, ' call ')
          .replace(/,\s*call\s*/i, ', call ')
          .replace(/\s{2,}/g, ' ');
        return;
      }

      control.replaceWith(phoneLink(control.className));
    });
  };

  clean(document);

  const observer = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        if (node.matches && (node.matches('a[href*="/pages/request-a-callback"]') || node.matches('[data-ph-callback-open]'))) {
          clean(node.parentElement || document);
        } else {
          clean(node);
        }
      }
    }));
  });

  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', event => clean(event.target || document));
})();
